// Updates the price-per-burrito text from the selected Kaching bundle bar.
function updatePriceFromBar(bar) {
  const priceEl = bar.querySelector('.kaching-bundles__bar-price');
  if (!priceEl) return;

  const price = priceEl.textContent.trim();
  if (!price || price === '$0.00') return;

  const targets = document.querySelectorAll('#bh-price-per-burrito');
  targets.forEach(el => {
    const packSize = parseInt(el.dataset.packSize || '1', 10);
    const match = price.match(/^(\D*)([\d,]+(?:\.\d+)?)(.*)$/);
    let perMealPrice = price;

    if (packSize > 1 && match) {
      const amount = parseFloat(match[2].replace(/,/g, ''));
      if (!Number.isNaN(amount)) {
        perMealPrice = match[1] + (amount / packSize).toFixed(2) + match[3];
      }
    }

    el.textContent = perMealPrice + ' / MEAL';
  });
}

// Watches the Kaching widget container for any DOM changes (re-renders, price updates).
// Kaching may render bars with base prices first, then re-render with discounted prices.
function watchForPriceChanges() {
  const container = document.querySelector('.kaching-bundles') || document.querySelector('.kaching-bundles__bars');
  if (!container) return;

  const observer = new MutationObserver(() => {
    const selected = document.querySelector('.kaching-bundles__bar--selected');
    if (selected) updatePriceFromBar(selected);
  });

  observer.observe(container, { characterData: true, childList: true, subtree: true });

  // Stop watching after 10 seconds — if Kaching hasn't updated by then, it won't.
  setTimeout(() => observer.disconnect(), 10000);
}

function initKachingPriceSync() {
  const bars = document.querySelectorAll('.kaching-bundles__bar');
  if (!bars.length) return false;

  const selected = document.querySelector('.kaching-bundles__bar--selected');
  if (!selected) return false;

  // Read whatever price is available now (may be base price on first pass)
  updatePriceFromBar(selected);

  // Watch for Kaching to update the price text with the actual discount
  watchForPriceChanges();

  // Use event delegation on the bars container for resilience against Kaching re-renders
  const container = document.querySelector('.kaching-bundles__bars');
  if (container) {
    container.addEventListener('click', (e) => {
      const bar = e.target.closest('.kaching-bundles__bar');
      if (bar) updatePriceFromBar(bar);
    });
  }

  return true;
}

function waitForKachingWidget() {
  if (initKachingPriceSync()) return;

  const observer = new MutationObserver((_, obs) => {
    if (initKachingPriceSync()) obs.disconnect();
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Safety valve: disconnect after 10 seconds if Kaching never loads
  setTimeout(() => observer.disconnect(), 10000);
}

document.addEventListener('DOMContentLoaded', waitForKachingWidget);
